import { useRef, useEffect } from "react";
import { Cookie } from "lucide-react";
import "./CookieBanner.scss";

/**
 * CookieBanner – fixovaný panel v ľavom dolnom rohu.
 *
 * Zobrazuje sa iba pri prvej návšteve alebo po zmene verzie politiky.
 * Poskytuje tri akcie: Prijať všetko / Odmietnuť / Nastaviť.
 *
 * Accessibility: focus trap nie je potrebný (banner nie je modal),
 * ale prvé tlačidlo dostane fokus automaticky pre klávesnicových používateľov.
 */
function CookieBanner({ onAcceptAll, onRejectAll, onCustomize }) {
  const firstBtnRef = useRef(null);

  // Presunúť fokus na prvé tlačidlo pri zobrazení bannera
  useEffect(() => {
    firstBtnRef.current?.focus();
  }, []);

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-modal="false"
      aria-label="Súhlas so súbormi cookie"
    >
      <div className="cookie-banner__icon" aria-hidden="true">
        <Cookie size={20} />
      </div>

      <div className="cookie-banner__body">
        <p className="cookie-banner__title">Používame cookies</p>
        <p className="cookie-banner__text">
          Nevyhnutné položky si pamätajú váš výber a chránia formulár pred
          robotmi. Marketingové cookies (Meta Pixel) sa načítajú iba po vašom
          súhlase.
        </p>
      </div>

      <div className="cookie-banner__actions" role="group" aria-label="Možnosti súhlasu">
        <button
          ref={firstBtnRef}
          className="cookie-banner__btn cookie-banner__btn--accept"
          onClick={onAcceptAll}
        >
          Prijať všetko
        </button>
        <button
          className="cookie-banner__btn cookie-banner__btn--customize"
          onClick={onCustomize}
        >
          Nastaviť
        </button>
        <button
          className="cookie-banner__btn cookie-banner__btn--reject"
          onClick={onRejectAll}
        >
          Odmietnuť
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
